// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"EditPlaceRetread_mainBlock__fZ4hC","buttonsWrapper":"EditPlaceRetread_buttonsWrapper__2D3rU"};